import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import SupplierOverviewService from 'src/modules/3rd-party-management/apis/admin/SupplierOverviewService';

export const SUPPLIER_OVERVIEW_EUDR_COMPLIANCE_CHECK_QUERY_KEY = '3rd-party-management-fetch-supplier-overview-eudr-compliance-check';

const useSupplierOverviewEudrComplianceCheck = ({
    supplierId,
    t,
}) => {
    return useQuery({
        queryKey: [SUPPLIER_OVERVIEW_EUDR_COMPLIANCE_CHECK_QUERY_KEY, supplierId],
        queryFn: async () => {
            const service = SupplierOverviewService.getInstance();

            return await service.fetchEudrComplianceCheckData(supplierId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!supplierId,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR compliance data.'), {
                type: 'error',
            });
        },
    });
};

export default useSupplierOverviewEudrComplianceCheck;
